var _ = require('underscore');
var Base = require('front/components/Base/Base');

var template = require('./TopNavPopup.jinja');
require('./TopNavPopup.less');

module.exports = Base.extend({

    template: template,

    events: {
        'touchstart': 'onTouchStart',
        'touchmove': 'onTouchMove',

        'click .TopNavPopup-navItem--logout': 'onLogoutClick',
        'click .TopNavPopup-navItem--login': 'onLoginClick'

        //'click nav li > a': 'toggleSubCategory'
    },


    initialize: function (options) {
        this.options = options || {};

        _.bindAll(this, 'show', 'hide', 'isShown');

        this.shown = false;

        this.$('.TopNavPopup-scrollbox').bind('scroll', function () {
            if (this.$('.TopNavPopup-scrollbox').scrollTop() > 50) {
                this.$('.TopNavPopup-scrollbox').unbind('scroll');
                this.$('.TopNavPopup-arrow').fadeOut(300);
            }
        }.bind(this));

        Base.prototype.initialize.call(this, options);
    },


    isShown: function () {
        return this.shown;
    },


    onLogoutClick: function () {
        window.app.vent.trigger('make-logout');
    },


    onLoginClick: function () {
        this.hide();
    },


    // toggleSubCategory: function (e) {
    //     var $category = $(e.currentTarget);
    //     var $prevSubCategory = this.$prevSubCategory;
    //     var $subCategory = $category.parent().find('.TopNavPopup-nestedList');

    //     if ($subCategory.length == 0) return;

    //     if ($(e.target).closest('.TopNavPopup-nestedList').length) return;

    //     e.preventDefault();

    //     if (this.$prevSubCategory) {
    //         this.$prevSubCategory.slideUp(150);
    //         delete this.$prevSubCategory;
    //     }

    //     if ($subCategory.is($prevSubCategory)) return;

    //     $subCategory.slideDown(150);

    //     this.$prevSubCategory = $subCategory;
    // },


    onTouchStart: function (e) {
        this.menuScrollY = e.originalEvent.touches.item(0).clientY;
    },


    onTouchMove: function (e) {
        var $scrollbox = this.$('.TopNavPopup-scrollbox');
        var $target = $(e.target);
        var delta = this.menuScrollY - e.originalEvent.touches.item(0).clientY;

        if (!$target.closest($scrollbox).length) {
            e.preventDefault();
        }

        if ((delta < 0 && $scrollbox.scrollTop() <= 0) ||
            (delta > 0 && $scrollbox.scrollTop() + $scrollbox.height() >= $scrollbox[0].scrollHeight)) {
            e.preventDefault();
        }

        this.menuScrollY = e.originalEvent.touches.item(0).clientY;
    },


    show: function () {
        //popup is initially dislay:none by inline style
        //to prevent visible glitch on page open
        if (this.$el.is(':hidden')) {
            this.$el
                .css('display', '')
                .outerHeight(); //to make css transition work
        }

        this.$el.addClass('TopNavPopup--opened');

        this.trigger('show');

        this.shown = true;
    },


    hide: function () {
        this.$el.removeClass('TopNavPopup--opened');

        this.trigger('hide');

        this.shown = false;
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/TopNav/TopNavPopup.js
// module id = 144
// module chunks = 0